import { useState, useEffect } from 'react';
import InfoIcon from './InfoIcon.jsx';
import { SOURCES } from '../data/sources.js';
import { formatDate } from '../lib/dates.js';
import './Countdown.css';

// 9:00 AM CDT (UTC-5) = 14:00 UTC. Hardcoded as UTC so it's correct
// regardless of the device's timezone setting.
const TARGET = new Date('2026-08-12T14:00:00Z');
const FIRST_DAY_ISO = '2026-08-12';

function getTimeLeft() {
  const totalMs = TARGET - Date.now();
  if (totalMs <= 0) return null;

  const totalMinutes = Math.floor(totalMs / 60_000);
  const days    = Math.floor(totalMinutes / 1440);
  const hours   = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  return { days, hours, minutes };
}

function isFirstDay() {
  const t = new Date();
  return t.getFullYear() === 2026 && t.getMonth() === 7 && t.getDate() === 12;
}

export default function Countdown() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  useEffect(() => {
    const id = setInterval(() => setTimeLeft(getTimeLeft()), 60_000);
    return () => clearInterval(id);
  }, []);

  if (timeLeft === null) {
    if (isFirstDay()) {
      return (
        <div className="countdown countdown--today" aria-live="polite">
          <p className="countdown-today-text">Today's the day!</p>
          <p className="countdown-today-sub">
            First day at Canyon Ridge — August 12, 2026
            <InfoIcon source={SOURCES.lisdCalendar2627} />
          </p>
        </div>
      );
    }

    return (
      <div className="countdown countdown--arrived" aria-live="polite">
        <p className="countdown-arrived-text">Welcome to year 1!</p>
        <p className="countdown-arrived-sub">You made it to Canyon Ridge.</p>
      </div>
    );
  }

  const { days, hours, minutes } = timeLeft;

  const dLabel = days === 1 ? 'day' : 'days';
  const hLabel = hours === 1 ? 'hour' : 'hours';
  const mLabel = minutes === 1 ? 'minute' : 'minutes';

  return (
    <div
      className="countdown"
      aria-label={`${days} days, ${hours} hours, and ${minutes} minutes until the first day of school`}
    >
      <p className="countdown-label" aria-hidden="true">
        <span className="countdown-num">{days}</span> {dLabel},{' '}
        <span className="countdown-num">{hours}</span> {hLabel}, and{' '}
        <span className="countdown-num">{minutes}</span> {mLabel} until first day at Canyon Ridge
      </p>

      <p className="countdown-date">
        {formatDate(FIRST_DAY_ISO, 'long')}
        <InfoIcon source={SOURCES.lisdCalendar2627} />
      </p>
    </div>
  );
}
